import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import {
  Form,
  Select,
  Input,
  Button,
  Card,
  Row,
  Col,
  Checkbox,
  InputNumber,
  Modal,
  Radio,
  Spin,

} from "antd"
import { CheckCircleOutlined, CloseCircleOutlined, ExclamationCircleOutlined, InfoCircleOutlined } from "@ant-design/icons";
import "./FormularioBasico.css";
import { MOTIVOS_NO_APTO_MEDICO } from "./motivosNoAptoMedico";

const FormularioBasico = () => {
  const API = "https://wwwa.isepsantafe.net.ar/expedientes/ingresos";

  //-------------Estas tres cosas hay que recibirlas desde el componente----------------------------

  const [bloqueadoPorApto, setBloqueadoPorApto] = useState(false);
  const [motivosNoApto, setMotivosNoApto] = useState([]);
  const [busquedaMotivo, setBusquedaMotivo] = useState("");
  const [mostrarAvisoNoApto, setMostrarAvisoNoApto] = useState(false);
  const [mostrarAvisoApto, setMostrarAvisoApto] = useState(false);

  // 👇 FIX: estos hooks estaban declarados ~150 líneas más abajo, pero se usan
  // en el useEffect de más abajo (en el array de dependencias, que se evalúa
  // de inmediato durante el render). Referenciar un const/let antes de su
  // línea de declaración tira "Cannot access before initialization" y rompe
  // el render completo del componente. Por eso "no andaban" los modales:
  // en realidad el componente entero crasheaba.
  const [habilitaEtapas, setHabilitaEtapas] = useState({});
  const [openModal, setOpenModal] = useState(false);
  const [soloLectura, setSoloLectura] = useState(false);
  const [disableaApto, setDisableaApto] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loadingSubmit, setLoadingSubmit] = useState(false);
  const navigate = useNavigate();

  const dniFormulario = localStorage.getItem("dniFormulario");
  const etapa = localStorage.getItem("etapa");
  const usuarioGuardo = localStorage.getItem("usuarioGuardo");
  const proceso = localStorage.getItem("proceso");
  const item_id = localStorage.getItem("item");
  const apellidoNombre = localStorage.getItem("apellidoNombre");




  console.log("El item id es:", item_id)
  console.log("La etapa es:", etapa)
  console.log("El proceso es:", proceso)

  const [form] = Form.useForm();
  const aptoActual = Form.useWatch(["apto"], form);
  console.log("VALOR APTO:", aptoActual);
  const conclusionFisicaSeleccionada = Form.useWatch(
    ["conclusionExamenFisico", "conclusionExamenFisico"],
    form
  );

  useEffect(() => {
    if (!openModal) {
      if (aptoActual === "apto") {
        setMostrarAvisoApto(true);
        setMostrarAvisoNoApto(false); // 👈 cierra el otro aviso si estaba abierto
      }

      if (aptoActual === "no_apto") {
        setMostrarAvisoNoApto(true);
        setMostrarAvisoApto(false); // 👈 cierra el otro aviso si estaba abierto
      }
    }
  }, [openModal]);

  const toggleMotivo = (motivo) => {
    setMotivosNoApto((prev) => {
      const existe = prev.some((m) => m.codigo === motivo.codigo);

      if (existe) {
        return prev.filter((m) => m.codigo !== motivo.codigo);
      }

      return [...prev, motivo];
    });
  };

  const motivosFiltrados = MOTIVOS_NO_APTO_MEDICO.filter((motivo) => {
    const texto = `${motivo.codigo} ${motivo.descripcion}`.toLowerCase();
    return texto.includes(busquedaMotivo.toLowerCase());
  });

  const handleValuesChange = (_, allValues) => {
    const peso = allValues?.examenFisico?.peso;
    const altura = allValues?.examenFisico?.altura;

    const imc = calcularIMC(peso, altura);

    if (imc) {
      form.setFieldsValue({
        examenFisico: {
          ...allValues.examenFisico,
          imc,
        },
      });
    }
  };
  const confirmarSalida = () => {
    Modal.confirm({
      title: "¿Seguro que desea salir?",
      icon: <ExclamationCircleOutlined />,
      content: "Se perderán los datos no guardados.",
      okText: "Sí, salir",
      cancelText: "Cancelar",
      okType: "danger",

      onOk: () => {
        window.close();
      },
    });
  };
  const togglePersonaItemService = async (condicion) => {
    try {
      const res = await axios.post(
        `${API}/togglePersonaItem`,
        {
          persona_id: dniFormulario,
          item_id,
          proceso_id: proceso,
          estado: condicion,
          tipo: "evaluacion",
          observaciones: "Calificado por " + usuarioGuardo,
        }
      );

      return res.data;
    } catch (error) {
      console.error("Error en togglePersonaItem:", error);
      throw error;
    }
  };
  const mostrarResultado = (tipo, mensaje) => {
    Modal.confirm({
      title:
        tipo === "success"
          ? "¡Éxito!"
          : tipo === "info"
            ? "Sin cambios"
            : "Error",

      icon:
        tipo === "success" ? (
          <CheckCircleOutlined style={{ color: "#52c41a" }} />
        ) : tipo === "info" ? (
          <InfoCircleOutlined style={{ color: "#1890ff" }} />
        ) : (
          <CloseCircleOutlined style={{ color: "#ff4d4f" }} />
        ),

      content: mensaje,
      okText: "Entendido",
      cancelButtonProps: { style: { display: "none" } },
      centered: true,

      onOk: () => {
        if (tipo === "success") {
          window.close();
        }
      }
    });
  };

  const obtenerCamposFaltantes = (values) => {
    const faltantes = [];

    if (habilitaEtapas.etapa1) {
      if (!values?.examenFisico?.peso) {
        faltantes.push("Peso");
      }

      if (!values?.examenFisico?.altura) {
        faltantes.push("Altura");
      }

      if (!values?.examenFisico?.imc) {
        faltantes.push("IMC");
      }
    }

    if (habilitaEtapas.etapa2) {
      if (!values?.odontologico?.observaciones) {
        faltantes.push("Observaciones odontológicas");
      }
    }

    if (habilitaEtapas.etapa3) {
      if (!values?.conclusionExamenFisico?.conclusionExamenFisico) {
        faltantes.push("Conclusión del examen físico");
      }

      if (
        values?.conclusionExamenFisico?.conclusionExamenFisico === "no_cumple" &&
        motivosNoApto.length === 0
      ) {
        faltantes.push("Motivo de No Cumple Requisitos Físicos");
      }
    }

    if (habilitaEtapas.etapa7) {
      if (!values?.recursoRevocatoriaDictamenGeneralPreocupacional?.conclusion) {
        faltantes.push("Conclusión de Revocatoria");
      }
    }

    if (habilitaEtapas.apto) {
      if (!values?.apto) {
        faltantes.push("Apto / No Apto");
      }
    }

    return faltantes;
  };

  const onFinish = async (values) => {
    /* if (bloqueadoPorApto) {
       Modal.warning({
         title: "Acción no permitida",
         content: "Este formulario ya fue evaluado y no puede modificarse.",
       });
       return;
     }*/

    // ==========================================
    // CAMPOS FALTANTES
    // ==========================================
    const camposFaltantes = obtenerCamposFaltantes(values);

    const noCumpleRequisitosFisicos =
      values?.conclusionExamenFisico?.conclusionExamenFisico === "no_cumple";

    if (noCumpleRequisitosFisicos && motivosNoApto.length === 0) {
      Modal.warning({
        title: "Motivo requerido",
        content:
          "Seleccione al menos un motivo por el cual no cumple los requisitos físicos.",
      });
      return;
    }

    const motivosTexto = noCumpleRequisitosFisicos
      ? motivosNoApto
        .map((m) => `${m.codigo} - ${m.descripcion}`)
        .join(" | ")
      : "";

    const valoresExamenFisico = {
      ...values,
      conclusionExamenFisico:
        values?.conclusionExamenFisico?.conclusionExamenFisico ||
          noCumpleRequisitosFisicos ||
          motivosNoApto.length > 0
          ? {
            ...values.conclusionExamenFisico,
            motivosNoApto: noCumpleRequisitosFisicos ? motivosNoApto : [],
            observaciones: undefined,
          }
          : {},
    };

    const data = {
      dniFormulario,
      etapa,
      usuario_registra: usuarioGuardo,
      valoresExamenFisico,
    };

    // ==========================================
    // FUNCIÓN REAL DE GUARDADO
    // ==========================================
    const guardar = async () => {
      setLoadingSubmit(true);

      try {
        const res = await axios.post(
          "https://wwwp.isepsantafe.net.ar/sanidad/preocupacional",
          data
        );

        const estadoFinal =
          values.apto === "apto"
            ? "aprobado"
            : values.apto === "no_apto"
              ? "rechazado"
              : "cargado";

        // ==========================================
        // RESULTADO DEL GUARDADO
        // ==========================================
        if (res.data.status !== "no_changes") {
          mostrarResultado(
            "success",
            "Los datos se guardaron correctamente."
          );
        } else {
          mostrarResultado(
            "info",
            "No se detectaron cambios. No se guardó un nuevo registro."
          );
        }

        // ==========================================
        // TOGGLE
        // ==========================================
        const toggleData = {
          persona_id: dniFormulario,
          item_id: localStorage.getItem("item"),
          estado: estadoFinal,
          tipo: "evaluacion",
          resultado:
            values.apto === "apto"
              ? "APTO"
              : values.apto === "no_apto"
                ? motivosTexto || "NO APTO"
                : "CARGADO",
          observaciones: motivosTexto
            ? `Carga desde examen físico. Motivos: ${motivosTexto}`
            : "Carga desde examen físico",
          proceso_id: proceso || "1",
        };

        try {
          await axios.post(
            "https://wwwa.isepsantafe.net.ar/expedientes/ingresos/togglePersonaItem",
            toggleData
          );
        } catch (errToggle) {
          console.error("Error en togglePersonaItem:", errToggle);
        }

      } catch (error) {
        mostrarResultado(
          "error",
          error?.response?.data?.detail ||
          "No se pudieron guardar los datos."
        );
      } finally {
        setLoadingSubmit(false);
      }
    };

    // ==========================================
    // SI HAY CAMPOS FALTANTES
    // ==========================================
    if (camposFaltantes.length > 0) {
      Modal.confirm({
        title: "Hay campos sin completar",
        icon: <ExclamationCircleOutlined />,

        content: (
          <div>
            <p>Los siguientes campos están sin completar:</p>

            <ul>
              {camposFaltantes.map((campo) => (
                <li key={campo}>{campo}</li>
              ))}
            </ul>

            <p>
              ¿Desea continuar y guardar el formulario igualmente?
            </p>
          </div>
        ),

        okText: "Continuar",
        cancelText: "Cancelar",
        centered: true,

        onOk: async () => {
          await guardar();
        },
      });

      return;
    }

    // ==========================================
    // NO HAY CAMPOS FALTANTES → GUARDA DIRECTAMENTE
    // ==========================================
    await guardar();
  };

  useEffect(() => {
    const fetchEtapas = async () => {

      setLoading(true); // 👈 arranca loading
      try {
        const res = await axios.post(
          "https://wwwp.isepsantafe.net.ar/sanidad/etapas",
          {
            etapa,
            dni: dniFormulario,
          }
        );

        const data = res.data;
        if (data.existeRegistro) {
          setOpenModal(true);

          form.setFieldsValue(data.datos.valoresExamenFisico);

          const motivosGuardados =
            data.datos.valoresExamenFisico?.conclusionExamenFisico
              ?.motivosNoApto ||
            data.datos.valoresExamenFisico?.motivosNoApto ||
            [];

          setMotivosNoApto(
            Array.isArray(motivosGuardados)
              ? motivosGuardados
              : []
          );

          // 👇 NUEVO
          /* if (data.datos.valoresExamenFisico?.apto) {
             setBloqueadoPorApto(true);
             setDisableaApto(true);
             setSoloLectura(true);
           }*/
        }
        setHabilitaEtapas(data.etapas || data);

        if (data.existeRegistro) {
          setOpenModal(true);

          form.setFieldsValue(data.datos.valoresExamenFisico);

          const motivosGuardados =
            data.datos.valoresExamenFisico?.conclusionExamenFisico
              ?.motivosNoApto ||
            data.datos.valoresExamenFisico?.motivosNoApto ||
            [];

          setMotivosNoApto(
            Array.isArray(motivosGuardados)
              ? motivosGuardados
              : []
          );
        }

      } catch (error) {
        console.error("Error trayendo etapas:", error);
      } finally {
        setLoading(false); // 👈 termina loading SIEMPRE
      }
    };

    fetchEtapas();
  }, [etapa, dniFormulario, form]);

  const camposFisicos = [
    { key: "pielFaneras", label: "Piel y Faneras" },
    { key: "visionAudicion", label: "Visión y Audición" },
    { key: "cardiovascular", label: "Aparato Cardiovascular" },
    { key: "respiratorio", label: "Aparato Respiratorio" },
    { key: "digestivo", label: "Aparato Digestivo" },
    { key: "genitoUrinario", label: "Aparato Génito/Urinario" },
    { key: "neurologico", label: "Examen Neurológico" },
    { key: "osteoMuscular", label: "Sistema Óseo-Muscular" },
  ];

  const examenesComplementarios = [
    { key: "radiografias", label: "Radiografias" },
    { key: "electrocardiograma", label: "Electrocardiograma" },
    { key: "electroencefalograma", label: "Electroencefalograma" },
    { key: "audiometria", label: "Audiometria" },
    { key: "oftalmologico", label: "Oftalmologico" },
    { key: "laboratorioClinico", label: "Laboratorio Clinico" },
  ];

  const calcularIMC = (peso, altura) => {
    if (!peso || !altura) return "";

    const p = parseFloat(peso);
    const a = parseFloat(altura);

    if (a === 0) return "";

    const imc = p / (a * a);
    return imc.toFixed(2);
  };
  return (
    <div style={{ maxWidth: 1200, margin: "20px auto" }}>
      <h1 className="titulo-formulario">
        Examen Médico General Preocupacional  <h4>Usuario carga: {usuarioGuardo}</h4>
        <h4>Postulante examinado {apellidoNombre + " dni:" + dniFormulario}</h4>
      </h1>

      <Card>
        <Spin spinning={loading}>
          <Form
            form={form}
            layout="vertical"
            onFinish={onFinish}
            disabled={soloLectura}
            onValuesChange={handleValuesChange}
            onFinishFailed={({ errorFields }) => {
              Modal.warning({
                title: "Atención",
                content: "Hay campos obligatorios sin completar.",
              });

              // 👇 te lleva al primer error
              if (errorFields.length > 0) {
                form.scrollToField(errorFields[0].name);
              }
            }}
          >



            {/* ===================== EXAMEN FISICO SECCION I ===================== */}

            {habilitaEtapas.etapa1 && (
              <>

                <h3>I. Examen Físico</h3>

                <Row gutter={16}>
                  <Col span={8}>
                    <Form.Item
                      label="Peso"
                      name={["examenFisico", "peso"]}
                      rules={[
                        {/* required: true, message: "Campo obligatorio"*/ },
                        {
                          pattern: /^\d+(\.\d+)?$/,
                          message: "Solo números (ej: 70 o 70.5)",
                        },
                      ]}
                    >
                      <Input
                        placeholder="Ej: 70"
                        onKeyDown={(e) => {
                          if (
                            !/[0-9.]/.test(e.key) &&
                            !["Backspace", "Tab", "ArrowLeft", "ArrowRight", "Delete"].includes(e.key)
                          ) {
                            e.preventDefault();
                          }

                          if (e.key === "." && e.currentTarget.value.includes(".")) {
                            e.preventDefault();
                          }

                          if (e.key === ",") {
                            e.preventDefault();
                          }
                        }}
                        onPaste={(e) => {
                          const paste = e.clipboardData.getData("text");
                          if (!/^\d+(\.\d+)?$/.test(paste)) {
                            e.preventDefault();
                          }
                        }}
                      />
                    </Form.Item>
                  </Col>

                  <Col span={8}>
                    <Form.Item
                      label="Altura"
                      name={["examenFisico", "altura"]}
                      rules={[
                        {/*required: true, message: "Campo obligatorio" */ },
                        {
                          pattern: /^\d+(\.\d+)?$/,
                          message: "Solo números (ej: 1.75)",
                        },
                      ]}
                    >
                      <Input
                        placeholder="Ej: 1.75"
                        onKeyDown={(e) => {
                          if (
                            !/[0-9.]/.test(e.key) &&
                            !["Backspace", "Tab", "ArrowLeft", "ArrowRight", "Delete"].includes(e.key)
                          ) {
                            e.preventDefault();
                          }

                          if (e.key === "." && e.currentTarget.value.includes(".")) {
                            e.preventDefault();
                          }

                          if (e.key === ",") {
                            e.preventDefault();
                          }
                        }}
                        onPaste={(e) => {
                          const paste = e.clipboardData.getData("text");
                          if (!/^\d+(\.\d+)?$/.test(paste)) {
                            e.preventDefault();
                          }
                        }}
                      />
                    </Form.Item>
                  </Col>

                  <Col span={8}>
                    <Form.Item
                      label="IMC"
                      name={["examenFisico", "imc"]}
                      rules={[
                        { /*required: true, message: "Campo obligatorio" */ },
                        {
                          pattern: /^\d+(\.\d+)?$/,
                          message: "Solo números con punto decimal (ej: 22.8)",
                        },
                      ]}
                    >
                      <Input

                        disabled placeholder="Se calcula automáticamente"
                        onKeyDown={(e) => {
                          if (
                            !/[0-9.]/.test(e.key) &&
                            !["Backspace", "Tab", "ArrowLeft", "ArrowRight", "Delete"].includes(e.key)
                          ) {
                            e.preventDefault();
                          }

                          // bloquear más de un punto
                          if (e.key === "." && e.currentTarget.value.includes(".")) {
                            e.preventDefault();
                          }

                          // bloquear coma
                          if (e.key === ",") {
                            e.preventDefault();
                          }
                        }}
                      />
                    </Form.Item>
                  </Col>
                </Row>

              </>
            )}

            {/* CHECKS */}

            {habilitaEtapas.evaluacionPorSistemas && (
              <>
                <h4>Evaluación por Sistemas</h4>

                <Form.Item name={["evaluacionPorSistemas", "sistemas"]}>
                  <Checkbox.Group>
                    <Row>
                      {camposFisicos.map((campo) => (
                        <Col span={12} key={campo.key}>
                          <Checkbox value={campo.key}>{campo.label}</Checkbox>
                        </Col>
                      ))}
                    </Row>
                  </Checkbox.Group>
                </Form.Item>

                {/* TEXTAREA GENERAL */}
                <Form.Item
                  label="Observaciones del Examen Físico"
                  name={["examenFisico", "observaciones"]}
                >
                  <Input.TextArea
                    rows={3}
                    placeholder="Observaciones generales..."
                  />
                </Form.Item>

              </>)}


            {/* ===================== ODONTOLOGICO SECCION II ===================== */}

            {habilitaEtapas.etapa2 && (
              <>
                <h3>II.Odontológico</h3>

                <Form.Item
                  label="Observaciones odontológicas"
                  name={["odontologico", "observaciones"]}
                  rules={[
                    { /*required: true, message: "Campo obligatorio"*/ },
                  ]}
                >
                  <Input.TextArea rows={3} />
                </Form.Item>

              </>)}

            {/* ===================== SECCION III ===================== */}

            {habilitaEtapas.etapa3 && (
              <>

                <h3>III. Conclusión del Examen Físico</h3>

                <Form.Item
                  name={["conclusionExamenFisico", "conclusionExamenFisico"]}
                  rules={[{ /*required: true, message: "Seleccione una opción" */ }]}
                >
                  <Select
                    placeholder="Seleccione"
                    onChange={(value) => {
                      if (value !== "no_cumple") {
                        setMotivosNoApto([]);
                        setBusquedaMotivo("");
                      }
                    }}
                    options={[
                      {
                        value: "continua",
                        label: "Continúa a Exámenes Complementarios",
                      },
                      {
                        value: "no_cumple",
                        label: "No Cumple Requisitos Físicos",
                      },
                    ]}
                  />
                </Form.Item>

                {/* MOTIVOS DINÁMICOS - reemplaza Cap. VII / Inciso / Punto */}
                {conclusionFisicaSeleccionada === "no_cumple" && (
                  <Card
                    size="small"
                    title="Motivos por los que No Cumple Requisitos Físicos"
                    style={{ marginBottom: 20 }}
                  >
                    <div
                      style={{
                        background: "#eff6ff",
                        border: "1px solid #bfdbfe",
                        padding: 10,
                        borderRadius: 8,
                        marginBottom: 10,
                        fontSize: 13,
                      }}
                    >
                      Seleccione uno o varios motivos. Para continuar debe elegir
                      al menos uno.
                    </div>

                    <Input
                      allowClear
                      disabled={soloLectura}
                      placeholder="Buscar por código o descripción. Ej: N1, F3, columna, diabetes..."
                      value={busquedaMotivo}
                      onChange={(e) => setBusquedaMotivo(e.target.value)}
                      style={{ marginBottom: 12 }}
                    />

                    <div
                      style={{
                        display: "grid",
                        gap: 8,
                        maxHeight: 320,
                        overflowY: "auto",
                        paddingRight: 5,
                      }}
                    >
                      {motivosFiltrados.map((motivo) => {
                        const checked = motivosNoApto.some(
                          (m) => m.codigo === motivo.codigo
                        );

                        return (
                          <Checkbox
                            key={motivo.codigo}
                            checked={checked}
                            disabled={soloLectura}
                            onChange={() => toggleMotivo(motivo)}
                            style={{
                              padding: 10,
                              borderRadius: 8,
                              border: checked
                                ? "1px solid #dc2626"
                                : "1px solid #ddd",
                              background: checked ? "#fee2e2" : "#f8fafc",
                            }}
                          >
                            <b>{motivo.codigo}</b> - {motivo.descripcion}
                          </Checkbox>
                        );
                      })}
                    </div>

                    {motivosNoApto.length > 0 && (
                      <div style={{ marginTop: 12, fontSize: 13 }}>
                        <b>Seleccionados:</b> {motivosNoApto.length}
                      </div>
                    )}
                  </Card>
                )}
              </>)}

            {/* ===================== SECCION V ===================== */}

            {habilitaEtapas.etapa5 && (
              <>
                <h3>V. Exámenes Complementarios</h3>

                <Form.Item name={["examenesComplementarios", "examenes"]}>
                  <Checkbox.Group>
                    <Row>
                      {examenesComplementarios.map((item) => (
                        <Col span={12} key={item.key}>
                          <Checkbox value={item.key}>{item.label}</Checkbox>
                        </Col>
                      ))}
                    </Row>
                  </Checkbox.Group>
                </Form.Item>

                <Form.Item
                  label="Observaciones de Exámenes Complementarios"
                  name={["examenesComplementarios", "observaciones"]}
                >
                  <Input.TextArea
                    rows={3}
                    placeholder="Observaciones generales..."
                  />
                </Form.Item>

              </>)}


            {/* ===================== SECCION VI ===================== */}

            {habilitaEtapas.etapa6 && (
              <>
                <h3>IV. Conclusiones Generales de Exámen Médico Preocupacional</h3>

                {/* OBSERVACIONES DINÁMICAS */}
                <Form.Item shouldUpdate noStyle>
                  {({ getFieldValue }) =>
                    getFieldValue(["conclusionGeneralExamenMedicoPreocupacional", "conclusionGeneralExamenMedico"]) ===
                      "no_cumple" ? (
                      <Form.List
                        name={["conclusionGeneralExamenMedicoPreocupacional", "observaciones"]}
                        rules={[
                          {
                            validator: async (_, observaciones) => {
                              if (!observaciones || observaciones.length === 0) {
                                return Promise.reject(
                                  new Error("Debe agregar al menos una observación")
                                );
                              }
                              return Promise.resolve();
                            },
                          },
                        ]}
                      >
                        {(fields, { add, remove }, { errors }) => (
                          <>
                            {fields.map(({ key, name, ...restField }) => (
                              <Row gutter={8} key={key}>
                                <Col span={6}>
                                  <Form.Item
                                    {...restField}
                                    name={[name, "capitulo"]}
                                    initialValue="Cap. VII-Inc."
                                  >
                                    <Input disabled />
                                  </Form.Item>
                                </Col>

                                <Col span={6}>
                                  <Form.Item
                                    {...restField}
                                    name={[name, "inciso"]}
                                    rules={[{/* required: true, message: "Requerido"*/ }]}
                                  >
                                    <Input placeholder="Inciso" />
                                  </Form.Item>
                                </Col>

                                <Col span={6}>
                                  <Form.Item
                                    {...restField}
                                    name={[name, "punto"]}
                                    rules={[{/* required: true, message: "Requerido" */ }]}
                                  >
                                    <Input placeholder="Punto" />
                                  </Form.Item>
                                </Col>

                                <Col span={6}>
                                  <Button danger onClick={() => remove(name)}>
                                    Eliminar
                                  </Button>
                                </Col>
                              </Row>
                            ))}

                            <Form.ErrorList errors={errors} />

                            <Button
                              type="dashed"
                              onClick={() => add()}
                              block
                              style={{ marginBottom: 20 }}
                            >
                              + Agregar Observación
                            </Button>
                          </>
                        )}
                      </Form.List>
                    ) : null
                  }
                </Form.Item>

                <Form.Item
                  label="Observación Conclusión General Examen Médico"
                  name={["conclusionGeneralExamenMedicoPreocupacional", "observacion"]}
                >
                  <Input.TextArea rows={3} placeholder="Opcional..." />
                </Form.Item>

              </>)}
            {/* ===================== SECCION VIII ===================== */}

            {habilitaEtapas.etapa7 && (
              <>
                <h3>VII. Recurso Revocatoria Del Dictamen General Preocupacional</h3>

                <Form.Item name={["recursoRevocatoriaDictamenGeneralPreocupacional", "conclusion"]}
                  rules={[{/* required: true, message: "Requerido" */ }]}>
                  <Select
                    placeholder="Seleccione"
                    options={[
                      { value: "continua", label: "Continúa" },
                      {
                        value: "no_cumple",
                        label: "No Cumple Requisitos Físicos",
                      },
                    ]}
                  />
                </Form.Item>

                <Form.Item
                  label="Observación Revocatoria"
                  name={["recursoRevocatoriaDictamenGeneralPreocupacional", "observacion"]}
                >
                  <Input.TextArea rows={3} placeholder="Opcional..." />
                </Form.Item>
              </>)}


            {/*APTO ----------- NO APTO */}

            {habilitaEtapas.apto && (
              <>
                {/* Apto - No Apto */}

                <Form.Item
                  name={["apto"]}
                  rules={[
                    // { required: true, message: "Debe seleccionar una opción" }
                  ]}
                  style={{
                    textAlign: "center",
                    marginBottom: "25px",
                  }}
                >
                  <Radio.Group
                    size="large"
                    // disabled={disableaApto}
                    className="grupo-apto-no-apto"
                  >
                    <div className="contenedor-apto-no-apto">

                      <Radio.Button
                        value="apto"
                        className="radio-apto"
                      >
                        <span className="icono-apto">✓</span>
                        <span>Apto</span>
                      </Radio.Button>

                      <Radio.Button
                        value="no_apto"
                        className="radio-no-apto"
                      >
                        <span className="icono-no-apto">✕</span>
                        <span>No Apto</span>
                      </Radio.Button>

                    </div>
                  </Radio.Group>
                </Form.Item>

              </>)}

            {/* ===================== BOTON ===================== */}
            <Button
              type="primary"
              htmlType="submit"
              block
              className="btn-guardar"
              disabled={loadingSubmit}
            >
              <span className="btn-guardar-icono">💾</span>
              Guardar
            </Button>

          </Form>

          <Button
            onClick={confirmarSalida}
            className="btn-salir"
          >
            Salir
          </Button>


          {/* 🔥 MODAL ACÁ */}
          <Modal
            open={openModal}
            onCancel={() => {
              setOpenModal(false);

              if (aptoActual === "no_apto") {
                setMostrarAvisoNoApto(true);
              }

              if (aptoActual === "apto") {
                setMostrarAvisoApto(true);
              }
            }}
            footer={null}
            title="Registro existente"
          >
            <p>Este DNI ya tiene un registro cargado.</p>
            <p>Se precargaron los datos en el formulario.</p>

            <Button
              type="primary"
              onClick={() => {
                setOpenModal(false);

                if (aptoActual === "no_apto") {
                  setMostrarAvisoNoApto(true);
                }

                if (aptoActual === "apto") {
                  setMostrarAvisoApto(true);
                }
              }}
            >
              Entendido
            </Button>
          </Modal>

          <Modal
            open={mostrarAvisoNoApto}
            onOk={() => setMostrarAvisoNoApto(false)}
            onCancel={() => setMostrarAvisoNoApto(false)}
            okText="Entendido"
            cancelButtonProps={{ style: { display: "none" } }}
            centered
            title="⚠️ POSTULANTE NO APTO"
          >
            <p>
              Actualmente este postulante se encuentra evaluado como{" "}
              <strong style={{ color: "#dc2626" }}>
                NO APTO
              </strong>.
            </p>

            <p>
              Revise la información cargada antes de continuar.
            </p>
          </Modal>

          <Modal
            open={mostrarAvisoApto}
            onOk={() => setMostrarAvisoApto(false)}
            onCancel={() => setMostrarAvisoApto(false)}
            okText="Entendido"
            cancelButtonProps={{ style: { display: "none" } }}
            centered
            title="✅ POSTULANTE APTO"
          >
            <p>
              Actualmente este postulante se encuentra evaluado como{" "}
              <strong style={{ color: "#16a34a" }}>
                APTO
              </strong>.
            </p>

            <p>
              Revise la información cargada antes de continuar.
            </p>
          </Modal>

        </Spin>

      </Card>

    </div>
  );
};

export default FormularioBasico;